import { environment } from './../../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, Input, Output, ViewChild, Inject, EventEmitter } from '@angular/core';
import { CustomersFilters } from '../../../model/customers';
import { DxDataGridComponent } from 'devextreme-angular';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomersService } from '../../../services/customers.service';
import { TrailerService } from '../../../services/trailers.service';
import { TrucksService } from '../../../services/trucks.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AttachmentsService } from '../../../services/attachments.service';
import { SetupDataService } from '../../../services/setupdata.service';
import { AttachmentsComponent } from '../../theme/attachments/attachments.component';
import { MatStepper } from '@angular/material/stepper';
import { TrucksFilters } from '../../../model/trucks';
import { DriversService } from '../../../services/driver.service';
import { DispatcherService } from '../../../services/dispatcher.service';
import { FuelcardService } from '../../../services/fuelcard.service';
import { DecimalPipe } from '@angular/common';
import { VendorService } from '../../../services/vendor.service';
import moment from 'moment';

@Component({
  selector: 'app-truck-creation-popup',
  templateUrl: './truck-creation-popup.component.html',
  styleUrls: ['./truck-creation-popup.component.scss'],
  providers: [CustomersService, TrucksService, TrailerService, DriversService, SetupDataService]
})
export class TruckCreationPopupComponent implements OnInit  {
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;


  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  public trucks: TrucksFilters;
  pageFilters: any = { truckUnitNumber: "" };
  maintenancedata = [];
  Truckslistdata = new Array<TrucksFilters>();
  @Input() datatype;
  @Input() disableClose;
  @Output() newItemEvent = new EventEmitter<string>();
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  mode = false;
  finalArry = [];
  driverdata = [];
  Dispatcherdata = [];
  trailerData = [];
  fuelData = [];
  unitNumberdata: any;
  categoryDetails = [];
  truckinfo = [];
  submitted = false;
  pageFiltersshow = false;
  maintenanceinfodata = {};
  showAddOption = false;
  showviewedit = false;
  item = "";
  itemShow = false;
  fileArray = [];
  base64FileArray = [];
  truckfiledata = {};
  URL = environment.uploadUrl;
  SelectedTruck = true;
  showupdate = false;
  showsubmit = false;
  changeUplaod = true;
  editFileList = [];
  btnHide = false;
  TrucklistdataId;
  truckForm: FormGroup;
  todayDate;
  truckId;
  vendorData: any[] = [];
  submittedLast = false;
  truckTypes =[]
  constructor(
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<TruckCreationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _trucksservice: TrucksService,
    private _driverService: DriversService,
    private _toaster: ToastrService,
    private router: Router,
    public dialog: MatDialog,
    private _attachementService: AttachmentsService,
    private decimalPipe: DecimalPipe,
  ) { }



  ngOnInit() {



    this.getTruckTypes();


    this.getDriverData();
    console.log(this.data);
    this.todayDate = new Date().toLocaleDateString("sv");
    if (this.data["EditMode"] == undefined) {
      this.mode = true;
      this.showAddOption = true;
      this.SelectedTruck = false;
      this.showsubmit = true;
    } else {
      this.mode = this.data["EditMode"];
      this.pageFilters = this.data;
      this.showAddOption = this.data["EditMode"];
      this.maintenancedata = this.data.maintenancedata;
      this.changeUplaod = false;

      if (this.pageFilters["startingMileage"] != undefined || this.pageFilters["startingMileage"] != null) {
        this.pageFilters["startingMileage"] = this.formatThousandSeperator(this.pageFilters["startingMileage"]);
      }
      if (this.pageFilters["currentMiles"] != undefined || this.pageFilters["currentMiles"] != null) {
        this.pageFilters["currentMiles"] = this.formatThousandSeperator(this.pageFilters["currentMiles"]);
      }
      if (this.pageFilters["insuranceValue"] != undefined || this.pageFilters["insuranceValue"] != null) {
        this.pageFilters["insuranceValue"] = this.formatThousandSeperator(this.pageFilters["insuranceValue"]);
      }
      if (this.pageFilters["installment"] != undefined || this.pageFilters["installment"] != null) {
        this.pageFilters["installment"] = this.formatThousandSeperator(this.pageFilters["installment"]);
      }
      if (this.pageFilters["installment1"] != undefined || this.pageFilters["installment1"] != null) {
        this.pageFilters["installment1"] = this.formatThousandSeperator(this.pageFilters["installment1"]);
      }
      if (this.pageFilters["expiryDate"] != undefined || this.pageFilters["expiryDate"] != null) {
        this.pageFilters["expiryDate"] = moment(this.pageFilters["expiryDate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["platesExpirationDate"] != undefined || this.pageFilters["platesExpirationDate"] != null) {
        this.pageFilters["platesExpirationDate"] = moment(this.pageFilters["platesExpirationDate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["insuranceExpirationDate"] != undefined || this.pageFilters["insuranceExpirationDate"] != null) {
        this.pageFilters["insuranceExpirationDate"] = moment(this.pageFilters["insuranceExpirationDate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["purchaseDate"] != undefined || this.pageFilters["purchaseDate"] != null) {
        this.pageFilters["purchaseDate"] = moment(this.pageFilters["purchaseDate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["operationDate"] != undefined || this.pageFilters["operationDate"] != null) {
        this.pageFilters["operationDate"] = moment(this.pageFilters["operationDate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["installmentDuedate"] != undefined || this.pageFilters["installmentDuedate"] != null) {
        this.pageFilters["installmentDuedate"] = moment(this.pageFilters["installmentDuedate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["leaseExpirydate"] != undefined || this.pageFilters["leaseExpirydate"] != null) {
        this.pageFilters["leaseExpirydate"] = moment(this.pageFilters["leaseExpirydate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["installmentDuedate1"] != undefined || this.pageFilters["installmentDuedate1"] != null) {
        this.pageFilters["installmentDuedate1"] = moment(this.pageFilters["installmentDuedate1"]).format("YYYY-MM-DD");
      }

      if (this.data["EditMode"]) {
        this.showupdate = true;
        this.editFileList = this.data["files"];
      }
    }

    this.pageFiltersshow = true;
    this.categoryDetails = [
      {
        ID: 0,
        Name: "Maintenance",
      },
      {
        ID: 1,
        Name: "Repairs",
      },
      {
        ID: 2,
        Name: "Rebuild",
      },
    ];

  }

  goBack() {
    this.dialogRef.close(null);
  }
  formatThousandSeperator(inputNumber) {
    return this.decimalPipe.transform(inputNumber, "1.2-10");
  }
  getDriverData() {
    this._driverService.getDriversData().subscribe((data) => {
      this.driverdata = data;
    });
  }

  reset() { }
  submitClicked = false;
  submit(truckForm) {
    this.submitClicked = true;
    if (truckForm.valid) {
      var Truckslistdata: any = this.pageFilters;
      Truckslistdata["maintenancedata"] = this.maintenancedata;
      Truckslistdata["companyId"] = localStorage.selectedCompany;
      Truckslistdata["files"] = [];

      // Truckslistdata["_id"] = this.TrucklistdataId;
      if (
        Truckslistdata.startingMileage != null &&
        Truckslistdata.startingMileage != "" &&
        Truckslistdata.startingMileage != undefined
      ) {
        Truckslistdata.startingMileage = Truckslistdata.startingMileage.toString().replace(/,/g, "");
      }

      if (
        Truckslistdata.price != null &&
        Truckslistdata.price != "" &&
        Truckslistdata.price != undefined
      ) {
        Truckslistdata.price = Truckslistdata.price.toString().replace(/,/g, "");
      }
      if (
        Truckslistdata.currentMiles != null &&
        Truckslistdata.currentMiles != "" &&
        Truckslistdata.currentMiles != undefined
      ) {
        Truckslistdata.currentMiles = Truckslistdata.currentMiles.toString().replace(/,/g, "");
      }
      if (
        Truckslistdata.insuranceValue != null &&
        Truckslistdata.insuranceValue != "" &&
        Truckslistdata.insuranceValue != undefined
      ) {
        Truckslistdata.insuranceValue = Truckslistdata.insuranceValue.toString().replace(/,/g, "");
      }
      if (
        Truckslistdata.installment != null &&
        Truckslistdata.installment != "" &&
        Truckslistdata.installment != undefined
      ) {
        Truckslistdata.installment = Truckslistdata.installment.toString().replace(/,/g, "");
      }
      if (
        Truckslistdata.installment1 != null &&
        Truckslistdata.installment1 != "" &&
        Truckslistdata.installment1 != undefined
      ) {
        Truckslistdata.installment1 = Truckslistdata.installment1.toString().replace(/,/g, "");
      }
        this.btnHide = true;
        this.submitted = true;
        this.submittedLast = true;
        if (this.TrucklistdataId != undefined) {
          this._trucksservice
            .SendForm(Truckslistdata)
            .subscribe(
              (response) => {

                if (response.Status == "error") {
                  this.btnHide = false;
                  this._toaster.error(response.error, "Failed", {
                    timeOut: 1000,
                  });
                } else {
                  this.submitted = true;
                  this._toaster.info("Truck Data Submitted", "Success", {
                    timeOut: 1000,
                  });
                  // this.goBack()
                  this.dialogRef.close(response);
                }
              },
              (error) => {
                let resError = JSON.parse(error._body);
                this.submitted = false;
                this._toaster.error(resError.error.error.message, "Failed", {
                  timeOut: 4000,
                });
              }
            );
        } else {
          this._trucksservice.SendForm(Truckslistdata).subscribe(
            (response) => {
              if (response.Status != "error") {
                if (response.result.errors) {
                  // this.submitted = false;
                  this.submittedLast = false;
                  this._toaster.info(response.result.message, "Failed", {
                    timeOut: 1000,
                  });
                }
                else {
                  this.submittedLast = true;
                  this._toaster.info("Trucks Data Submitted", "Success", {
                    timeOut: 1000,
                  });
                  this.btnHide = false;
                  this.TrucklistdataId = response["result"]["_id"];
                  console.log(this.TrucklistdataId);
                  this.dialogRef.close(response);
                  // this.goBack();
                }
              } else {
                this.submittedLast = false;
                this._toaster.info(response.error, "Failed", {
                  timeOut: 1000,
                });
              }
            },
            (error) => {
              this.submittedLast = false;
              if (typeof error.error === "string") {
                this._toaster.error(error.error, "Failed", {
                  timeOut: 4000,
                });
              }
              else {
                let resError = JSON.parse(error._body);
                if (typeof resError.error === "string") {
                  this._toaster.error(resError?.error, "Failed", {
                    timeOut: 4000,
                  });
                }
                else {
                  this._toaster.error(resError?.error?.error?.message, "Failed", {
                    timeOut: 4000,
                  });
                }
              }
            }
          );
        }
        // this.goBack();
      
    }
    else {
      this.onFromValidation(truckForm, 'add')
    }
    // this.stepper.next();
  }
  formErrors = [];

  onChangeDate(event, formData) {
    Object.keys(formData.controls).forEach((key) => {
      switch (key) {
        case 'expiryDate':
          if (new Date(formData.controls[key].value) < new Date(this.todayDate)) {
            formData.controls[key].setErrors({ dateError: "invalid date" });
          }
          break;
        case 'platesExpirationDate':
          if (new Date(formData.controls[key].value) < new Date(this.todayDate)) {
            formData.controls[key].setErrors({ dateError: "invalid date" });
          }
          break;
        case 'insuranceExpirationDate':
          if (new Date(formData.controls[key].value) < new Date(this.todayDate)) {
            formData.controls[key].setErrors({ dateError: "invalid date" });
          }
          break;

        default:
          break;
      }
    })
  }
  onFromValidation(form, actionType, stepper = null) {
    let formData = form.controls;
    let check = false;
    let timeout = 3000;
    Object.keys(formData).forEach((key) => {
      if (check) {
        return;
      }
      if (formData[key].errors) {
        console.log(key, formData[key].errors)
        if (key === "truckUnitNumber") {
          if (formData[key].errors.required) {
            this._toaster.error("Unit Number is required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.pattern) {
            this._toaster.error("Unit Number allowed only Alphanumeric values", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "registerdState") {
          if (formData[key].errors.required) {
            this._toaster.error("State Code is required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.pattern) {
            this._toaster.error("Sate Code allowed only Alphanumeric values", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            this._toaster.error("Two digit state code", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "plate") {
          if (formData[key].errors.required) {
            this._toaster.error("Plate is required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.pattern) {
            this._toaster.error("Plate allowed only Alphanumeric values", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "vin") {
          if (formData[key].errors.required) {
            this._toaster.error("Vin is required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.pattern) {
            this._toaster.error("Vin allowed only Alphanumeric values", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "startingMileage") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Starting Mileage allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            let amount = Number(formData[key].value.toString().replace(/,/g, "")).toString();
            if (formData[key].errors.maxlength.requiredLength >= amount.length) {
              formData[key].setErrors(null);
              this.submit(form);
            }
          }
        }
        else if (key === "currentMiles") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Current Miles allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            let amount = Number(formData[key].value.toString().replace(/,/g, "")).toString();
            if (formData[key].errors.maxlength.requiredLength >= amount.length) {
              formData[key].setErrors(null);
              this.submit(form);
            }
          }
        }
        else if (key == "expiryDate") {
          this._toaster.error("Please enter a valid expiry date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if (key == "platesExpirationDate") {
          this._toaster.error("Please enter a valid plates expiration date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if (key == "insuranceExpirationDate") {
          this._toaster.error("Please enter a valid insurance expiration date ", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if (key === "yom") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Year of Make allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            this._toaster.error("Year of Make must be 4 numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "insuranceValue") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Insurance Value allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            let amount = Number(formData[key].value.toString().replace(/,/g, "")).toString();
            if (formData[key].errors.maxlength.requiredLength >= amount.length) {
              formData[key].setErrors(null);
              this.submit(form);
            }
          }
        }
        else if (key === "price") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Price Value allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            let price = Number(formData[key].value.toString().replace(/,/g, "")).toString();
            if (formData[key].errors.maxlength.requiredLength >= price.length) {
              formData[key].setErrors(null);
              this.submit(form);
            }
          }
        }
        else if (key === "leaaseStart") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Lease Start allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "installment") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Installment allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            let amount = Number(formData[key].value.toString().replace(/,/g, "")).toString();
            if (formData[key].errors.maxlength.requiredLength >= amount.length) {
              formData[key].setErrors(null);
              this.submit(form);
            }
          }
        }
        else if (key === "installment1") {
          if (formData[key].errors.pattern) {
            this._toaster.error("Installment allowed only numbers", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if (formData[key].errors.maxlength || formData[key].errors.minlength) {
            let amount = Number(formData[key].value.toString().replace(/,/g, "")).toString();
            if (formData[key].errors.maxlength.requiredLength >= amount.length) {
              formData[key].setErrors(null);
              this.submit(form);
            }
          }
        }
        else {
          this._toaster.error("Please fix the validations", "Failed", {
            timeOut: 1000,
          });
          check = true;
        }
      }
    });
  
  }
  getTruckTypes() {
    // this.truckTypes = this.baseTruckTypes;
    this._trucksservice.getTruckTypesData().subscribe((data) => {
      console.log("truck type ", data);

    for (var i = 0; i < data.result.length; i++) {
          if (data.result[i].name != undefined && data.result[i].type == localStorage.getItem("companyType")) {
          this.truckTypes.push({
            value: data.result[i].name
          });
        }
      }
    });
  }

}

